import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export const ChatBlockedAlert = () => {
  const { t } = useTranslation('liveChat')

  return (
    <Alert variation="warn" className='ds-u-margin-top--3'>
      {t('blocked')}
    </Alert>
  )
}
